import { OptLockDTO } from './optLockDTO';

export class TraceModificationDTO extends OptLockDTO {
    insertDate: Date;
    insertUser: string;
    updateDate: Date;
    updateUser: string;
}